import { render, staticRenderFns } from "./noticias-recientes.vue?vue&type=template&id=90103e1e&scoped=true"
import script from "./noticias-recientes.vue?vue&type=script&lang=js"
export * from "./noticias-recientes.vue?vue&type=script&lang=js"
import style0 from "./noticias-recientes.vue?vue&type=style&index=0&id=90103e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90103e1e",
  null
  
)

export default component.exports